(function () {
  const RESTORE_LABEL_MODAL_MESSAGE =
    'Some vitamins and supplements may not be right for everyone, particularly if you have allergies, are pregnant or breastfeeding, or take other medications. Always read the label and follow the directions for use.\n\n' +
    'If you\'re unsure, speak to your doctor or healthcare professional.';

  function getReviewRedirectUrl() {
    if (window.personalised?.config?.routes?.review) return window.personalised.config.routes.review;
    if (window.personalised?.config?.routes?.reviewV1) return window.personalised.config.routes.reviewV1;
    if (window.personalised?.config?.routes?.reviewV2) return window.personalised.config.routes.reviewV2;
    return '/pages/review-pack';
  }

  function getLibraryRedirectUrl() {
    if (window.personalised?.config?.routes?.library) return window.personalised.config.routes.library;
    if (window.personalised?.config?.routes?.libraryV1) return window.personalised.config.routes.libraryV1;
    if (window.personalised?.config?.routes?.libraryV2) return window.personalised.config.routes.libraryV2;
    return '/pages/library-v2';
  }

  function redirectTo(url) {
    try {
      window.location.replace(url || '/');
    } catch (err) {
      window.location.href = url || '/';
    }
  }

  function normalizeShopifyId(value) {
    if (value === null || value === undefined || value === '') return null;
    const normalized = String(value).trim();
    if (!normalized) return null;
    const num = Number(normalized);
    return Number.isFinite(num) ? String(num) : normalized;
  }

  function getFallbackSellingPlanId(frequency, variantId) {
    const labels = window.personalised?.config?.subscription?.DEFAULT_SELLING_PLAN_LABELS || {
      '30': '30_day_subscription',
      '60': '60_day_subscription_with_15%_discount',
      '90': '90_day_subscription_with_20%_discount'
    };

    const label = labels[String(frequency)] || labels['30'];
    const sellingPlans = window.personalised?.sellingPlans || {};
    const plansForVariant = sellingPlans[variantId] || {};
    return plansForVariant[label] || null;
  }

  async function showRestoreLabelModal() {
    const show = window.personalised?.labelModal?.showLabelModal;
    if (typeof show !== 'function') return true;

    const confirmed = await show(RESTORE_LABEL_MODAL_MESSAGE);
    return !!confirmed;
  }

  async function restorePackFromToken() {
    const params = new URLSearchParams(window.location.search || '');
    const token = params.get('token') || params.get('t');
    const libraryUrl = getLibraryRedirectUrl();
    const reviewUrl = getReviewRedirectUrl();

    if (!token) {
      redirectTo(libraryUrl);
      return;
    }

    const endpoint = '/apps/api/prod/recommendation/quiz/pack-migration/' + encodeURIComponent(token);

    try {
      const response = await fetch(endpoint, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.status === 401) {
        redirectTo(libraryUrl);
        return;
      }

      const payload = await response.json().catch(function () {
        return null;
      });

      if (!payload || payload.status !== 'ok') {
        redirectTo(libraryUrl);
        return;
      }

      const frequency = String(payload.frequency || '30');
      const items = Array.isArray(payload.items) ? payload.items : [];
      const normalizedItems = items
        .map(function (item) {
          if (!item) return null;

          const normalizedProductId = normalizeShopifyId(item.productId);
          const normalizedVariantId = normalizeShopifyId(item.variantId);

          if (!normalizedProductId || !normalizedVariantId) return null;

          const quantity = Number(item.quantity);
          const resolvedSellingPlanId = item.sellingPlanId || getFallbackSellingPlanId(frequency, normalizedVariantId);
          const normalizedSellingPlanId = normalizeShopifyId(resolvedSellingPlanId);

          // Drop discontinued variants that cannot be mapped to a valid selling plan.
          if (!normalizedSellingPlanId) return null;

          return {
            productId: normalizedProductId,
            variantId: normalizedVariantId,
            collectionId: item.collectionId || null,
            quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
            sellingPlanId: normalizedSellingPlanId
          };
        })
        .filter(Boolean);

      if (!['30', '60', '90'].includes(frequency) || normalizedItems.length === 0) {
        redirectTo(libraryUrl);
        return;
      }

      const saved = window.personalised?.storageManager?.saveBundleState
        ? window.personalised.storageManager.saveBundleState({
            frequency: frequency,
            items: normalizedItems
          })
        : false;

      if (!saved) {
        try {
          localStorage.setItem('personalised_bundle_state', JSON.stringify({
            frequency: frequency,
            items: normalizedItems
          }));
        } catch (err) {
          console.warn('[RestorePage] Failed to save bundle state to localStorage', err);
        }
      }

      try {
        if (window.personalised?.storageManager?.setMode) {
          window.personalised.storageManager.setMode('guest', { source: 'afterpay-restore' });
        } else {
          sessionStorage.setItem('personalised_mode', JSON.stringify({
            mode: 'guest',
            timestamp: Date.now(),
            source: 'afterpay-restore'
          }));
        }
      } catch (err) {
        console.warn('[RestorePage] Failed to set guest mode', err);
      }

      const confirmed = await showRestoreLabelModal();
      if (!confirmed) {
        redirectTo(libraryUrl);
        return;
      }

      redirectTo(reviewUrl);
    } catch (err) {
      console.warn('[RestorePage] Pack restore failed', err);
      redirectTo(libraryUrl);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    restorePackFromToken();
  });
})();
